/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ProductPrice from '../ProductPrice';
import ProductSnipcartButton from './ProductSnipcartButton';

/** A button to buy via Snipcart. */
export default function ProductBuyWithSnipcartButton({ product, ...rest }) {
  if (product.price == null) return null;
  return (
    <ProductSnipcartButton
      product={product}
      data-item-price={product.price}
      {...rest}
    >
      <Trans>Add to cart</Trans>{' '}
      <ProductPrice product={product} sx={{ paddingLeft: 2, opacity: 0.8 }} />
    </ProductSnipcartButton>
  );
}

export const fragment = graphql`
  fragment bb_ProductBuyWithSnipcartButton on Bottlebooks_Product {
    ...bb_ProductSnipcartButton
  }

  fragment ProductBuyWithSnipcartButton on Product {
    # properties not yet on api.bottlebooks.me
    bottleSize
    ...ProductPrice
  }
`;

ProductBuyWithSnipcartButton.fragment = gql`
  fragment ProductBuyWithSnipcartButton on Product {
    ...ProductSnipcartButton
    # bottleSize TODO not yet available on api.bottlebooks.me
    ...ProductPrice
  }
  ${ProductSnipcartButton.fragment}
  ${ProductPrice.fragment}
`;
